import Vue from 'vue'
import { Component, Prop } from "vue-property-decorator";
import { Action, Getter, namespace } from 'vuex-class';
import { LabelSetting } from '../../../../i18n/locale-helper';
import { IBasePositiveAndNegative } from '../../../../models/common/AgendaCommon';
import { IPropertyHistoryProspectModel } from '../../../../models/history/property-history-response.model';
import { storeModules } from '../../../../store';
import HistoryTypes from '../../../../store/history/history-types.store';
import { DataHelper } from '../../../../utils/data-helper';
import { deepCopy, orderBy } from '../../../../utils/util';

const LookupGetter = namespace(storeModules.Lookup, Getter);
const HistoryAction = namespace(storeModules.History, Action);
@Component({
  template: require("./template.html"),
})

class EditProspectComponent extends Vue {
    @Prop() rowData: any;
    @Prop() visible: boolean;

    @LookupGetter listOfNegativeComments: IBasePositiveAndNegative[];
    @HistoryAction(HistoryTypes.Set.EDIT_PROSPECT_HISTORY)
    updateProspect: (payload: { paramOrigin: IPropertyHistoryProspectModel, param: IPropertyHistoryProspectModel}) => Promise<boolean>;

    dtsource: any = null;
    visiblePopover: boolean = false;
    
    get lblSetting() {
        return LabelSetting.Property;
    }

    get lblAgenda() {
        return LabelSetting.Agenda;
    }

    get fieldName() { return "Name" + this.$i18n.locale.substring(0, 2).toLocaleUpperCase() }

    get title () {
        return this.dtsource ? this.dtsource.Name : "";
    }
    
    get coListOfNegative() {
        let getList = this.listOfNegativeComments || [];
        return orderBy(getList, this.fieldName, 1);
    }

    get coOffer () {
        return this.dtsource ? this.dtsource.Offer : 0;
    }

    set coOffer (val: number) {
        this.dtsource.Offer = Number(val);
    }

    get coPriceEstimate () {
        return this.dtsource ? this.dtsource.PriceEstimate : 0;
    }

    set coPriceEstimate (val: number) {
        this.dtsource.PriceEstimate =  Number(val);
    }

    get coNoInterestReason() {
        const vm = this as any;
        let list = [];
        vm.coListOfSelectedIds.forEach(id => {
            let obj = vm.coListOfNegative.find(e => e.Id === id);
            if (obj) {
                list.push(vm.$td(obj, "Name"));
            }
        });
        return list.join(", ");
    }

    get coListOfSelectedIds () {
        console.log("coListOfSelectedIds-get", this.dtsource && this.dtsource.NoInterestReasonIds ? this.dtsource.NoInterestReasonIds: []);
        return this.dtsource && this.dtsource.NoInterestReasonIds ? this.dtsource.NoInterestReasonIds: [];
    }

    set coListOfSelectedIds (ids) {
        console.log("coListOfSelectedIds-set", ids);
        if (this.dtsource) {
            this.dtsource.NoInterestReasonIds = ids;
        }
    }

    get coListOfSelected () {
        if (this.coListOfSelectedIds.length > 0 && this,this.coListOfNegative.length > 0) {
            return this.coListOfNegative.filter(e => {
                    return this.coListOfSelectedIds.indexOf(e.Id) > -1;
                });
        }
        return [];
    }

    set coListOfSelected (selectedItems) {
        console.log("coListOfSelected", selectedItems);
    }

    get isSavable () {
        const diff = DataHelper.compare(this.dtsource, this.rowData);
        console.log("isSavable", this.dtsource, this.rowData);
        return !!diff;
    }

    get coNoMoreInterest() {
        return this.dtsource && this.dtsource.NoMoreInterest === 1 ? true: false;
    }

    set coNoMoreInterest(val: boolean) {
        this.dtsource.NoMoreInterest = (val === true) ? 1 : 0;
    }

    get coRelaunch() {
        return this.dtsource && this.dtsource.Relaunch === 1 ? true: false;
    }

    set coRelaunch(val: boolean) {
        this.dtsource.Relaunch = (val === true) ? 1 : 0;
    }

    getCoListOfSelected (ids: number[]) {
        if (ids == null || this.coListOfNegative.length == 0) return [];

        return this.coListOfNegative.filter(e => {
            return ids.indexOf(e.Id) > -1;
        });
    }

    handleBeforeClose() {
        this.dtsource = null;
        this.$emit("update:rowData", null);
    }

    handleSave () {
        if (!!this.dtsource) {
            let payload = {
                paramOrigin: {...this.rowData},
                param: {...this.dtsource}
            };
            this.updateProspect(payload).then(result => {
                this.$emit("refresh-history-prospect");
            }).catch(err => {
                console.log(err);
            })
        }
        this.handleBeforeClose();
    }
    
    handleOpenModal () {
        this.dtsource = deepCopy(this.rowData);
    }
}
export default EditProspectComponent;